import React, { Suspense, useEffect } from 'react';
import InitApm from './core/apm';
import Router from './core/routes';
import { RouterProvider } from 'react-router-dom';
import './index.css';
import 'swiper/swiper-bundle.css';
import { Toast } from './core/components/atoms/Toast';
import { setAuthToken } from './core/commom/authToken';
import { useUserStore } from './modules/Auth/stores/authStore';
import { setTheme } from './core/utils';
import { BLACK_FRIDAY_ENABLED } from './modules/Gamification/components/Common/BlackFriday';
import { isBlack2026DarkDefault } from './modules/MyArea/utils/black2026';
import GTM from './core/track/gtm';
import { loadScriptCubos } from './core/track/cubos';
import { loadWootric } from './core/track/wootric';
import { AuthRoutes } from './modules/Auth/routes';
import iaAssistant from './core/track/iaAssistant';
import GlobalFreemiumUpsell from './core/components/organism/FreemiumLockModal/GlobalFreemiumUpsell';
import GlobalMostraSeuAprova from './core/components/organism/MostraSeuAprovaModal/GlobalMostraSeuAprova';

export default function App() {
  const { user, setUser } = useUserStore();

  function updateUserTheme() {
    if (window.location.pathname.includes('/simuladao')) {
      setTheme('light');
      return;
    }

    // Telas de autenticação (login, recuperar senha, callbacks sociais...) NÃO
    // entram no "tema black" — seguem o tema normal (claro quando deslogado).
    const isAuthPage = AuthRoutes.map((route) => route.path.split('/')[0])
      .filter(Boolean)
      .some((path) => window.location.pathname.includes(path));

    // Durante a campanha Black, o modo escuro é o padrão ("tema black") dentro do
    // app logado. Só respeitamos o modo claro se o aluno tiver escolhido
    // explicitamente (flag gravada ao trocar o tema). Independe do `user` estar
    // carregado, evitando "piscar" do claro para o escuro.
    if (BLACK_FRIDAY_ENABLED && !isAuthPage) {
      setTheme(isBlack2026DarkDefault() ? 'dark' : 'light');
      return;
    }

    setTheme(user && user.isDarkMode ? 'dark' : 'light');
  }

  useEffect(() => {
    InitApm();
    GTM();

    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    if (params.has('token')) {
      const token = params.get('token');
      if (token) {
        setAuthToken(token);
      }
    }
  }, []);

  useEffect(() => {
    if (user && user.email) {
      loadWootric(user);
    }
  }, [user]);

  useEffect(() => {
    if (user && window) {
      iaAssistant(user);
    }
    return () => {
      console.log('unmount');
    };
  }, [user, window]);

  // Durante a campanha, o tema efetivo é dark por padrão (ou a escolha explícita
  // do aluno). Vários componentes (dropdowns do header, logos, bottom menu...)
  // escolhem cor a partir de `user.isDarkMode` em JS — então sincronizamos esse
  // valor no store com o tema efetivo, senão a cor por JS fica dessincronizada
  // da classe `dark` aplicada no HTML.
  useEffect(() => {
    if (!BLACK_FRIDAY_ENABLED || !user) return;
    const dark = isBlack2026DarkDefault();
    if (user.isDarkMode !== dark) {
      setUser({ ...user, isDarkMode: dark });
    }
  }, [user]);

  useEffect(() => {
    updateUserTheme();
  }, [user?.isDarkMode]);

  useEffect(() => {
    const authPaths = AuthRoutes.map((route) => route.path.split('/')[0]);

    const isInAuth = authPaths.some((path) =>
      window.location.pathname.includes(path)
    );

    if (!isInAuth) {
      localStorage.setItem('lastPath', window.location.pathname);
    }

    updateUserTheme();
  }, [window.location.pathname]);

  return (
    <Suspense fallback={<></>}>
      <Toast />
      <GlobalFreemiumUpsell />
      <GlobalMostraSeuAprova />
      <RouterProvider router={Router} fallbackElement={<p>Carregando</p>} />
    </Suspense>
  );
}
